
import Vue from 'vue';
import { ConfirmableDialogData, DialogOptions } from '../../interfaces/common.interface';

export default Vue.extend({
  name: 'UpgradeToAccessDialog',
  props: {
    hideCancelButton: Boolean
  },
  data: (): ConfirmableDialogData => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: 'primary',
      width: 400,
      zIndex: 200
    }
  }),
  methods: {
    open(title: string, message: string, options: DialogOptions) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      if (this.resolve) {
        this.$router.push({ name: 'UpgradeToPremium' });
        this.resolve(true);
        this.dialog = false;
      }
    },
    cancel() {
      if (this.resolve) {
        this.resolve(false);
        this.dialog = false;
      }
    }
  }
});
